<template>
  <div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-12">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-2">
                    <div><label>เดือน</label></div>
                    <a-month-picker
                      v-model:value="month"
                      placeholder="เลือกเดือน"
                      :format="monthFormat"
                      :allow-clear="false"
                    />
                  </div>
                  <div class="col-md-2">
                    <div><label>รายการ</label></div>
                    <a-select
                      mode="multiple"
                      v-model:value="selects.actionType"
                      style="width: 100%"
                      placeholder="เลือกรายการ"
                      v-if="selects.actionTypesLoaded"
                      :options="selects.actionTypes"
                    />
                  </div>
                  <div class="col-md-2">
                    <div><label>สถานะ</label></div>
                    <a-select
                      mode="multiple"
                      v-model:value="selects.status"
                      style="width: 100%"
                      placeholder="เลือกสถานะ"
                      v-if="selects.statusLoaded"
                      :options="selects.statuses"
                    />
                  </div>
                  <div class="col-md-2">
                    <div><label>หมายเลขรายกการ</label></div>
                    <a-input
                      v-model:value="transactionNo"
                      placeholder="หมายเลขรายการ"
                      v-on:keyup.enter="getTransactions()"
                      allow-clear
                    />
                  </div>
                  <div class="col-md-2">
                    <div><label>ชื่อ Agent</label></div>
                    <a-input
                      v-model:value="agentName"
                      placeholder="ชื่อ Agent"
                      v-on:keyup.enter="getTransactions()"
                      allow-clear
                    />
                  </div>
                  <div class="col-md-2">
                    <div><label style="color: transparent">ค้นหา</label></div>
                    <a-button type="primary" @click="getTransactions()">
                      ค้นหา
                    </a-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess">
      <div class="col-12">
        <div class="card">
          <div class="row">
            <div class="col-8">
              <div class="card-header">
                <h4 class="card-title">รายการ</h4>
              </div>
            </div>
            <div class="col-4">
              <div class="card-header text-right">
                <a-button
                  class="card-title"
                  type="primary"
                  @click="showAddModal(0)"
                >
                  เติมเงิน
                </a-button>
                <a-divider type="vertical" />
                <a-button class="card-title" shape="round" @click="onExport">
                  ดาวน์โหลด
                </a-button>
              </div>
            </div>
          </div>
          <div class="card-body">
            <a-table
              :columns="columns"
              :data-source="transactions"
              :loading="transactionsLoaded"
              :scroll="{ x: 1200 }"
            >
              <template #transDate="{ record }">
                {{ getDate(record.createdDate) }}
              </template>
              <template #amount="{ record }">
                {{ getCurrency(record.amount) }}
              </template>
              <template #action="{ record }">
                <a href="#" @click="showModal(record.id)">รายละเอียด</a>
              </template>
              <template #status="{ record }">
                <a-tag
                  :color="
                    record.statusId === 'approve'
                      ? 'success'
                      : record.statusId === 'reject'
                      ? 'warning'
                      : record.statusId === 'cancel'
                      ? 'error'
                      : 'processing'
                  "
                  >{{ record.status }}</a-tag
                >
              </template>
            </a-table>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="canAccess === false">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <a-result
              status="403"
              title="403"
              sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
            >
              <template #extra>
                <a-button type="primary" @click="goToHome"
                  >กลับหน้าหลัก</a-button
                >
              </template>
            </a-result>
          </div>
        </div>
      </div>
    </div>

    <a-modal
      destroyOnClose="true"
      v-model:visible="visible"
      title="รายละเอียด"
      @ok="handleOk"
      okText="อนุมัติ"
      :confirm-loading="confirmLoading"
    >
      <template #footer>
        <a-button
          key="back"
          :loading="cancelLoading"
          :disabled="approveBox.statusId !== 'waiting_approve'"
          @click="handleCancel"
          >ไม่อนุมัติ</a-button
        >
        <a-button
          key="submit"
          type="primary"
          :loading="confirmLoading"
          :disabled="approveBox.statusId !== 'waiting_approve'"
          @click="handleOk"
          >อนุมัติ</a-button
        >
      </template>
      <div class="row">
        <div class="col-4">
          <p>สถานะ</p>
        </div>
        <div class="col-8">
          <p>{{ approveBox.status }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>หมายเลขรายการ</p>
        </div>
        <div class="col-8">
          <p>{{ approveBox.no }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>วันที่ทำรายการ</p>
        </div>
        <div class="col-8">
          <p>{{ getDate(approveBox.createdDate) }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>ชื่อ Agent</p>
        </div>
        <div class="col-8">
          <p>{{ approveBox.agentName }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>ชื่อ - สกุล</p>
        </div>
        <div class="col-8">
          <p>{{ approveBox.fullName }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>เบอร์โทร</p>
        </div>
        <div class="col-8">
          <p>{{ approveBox.tel }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>อีเมล</p>
        </div>
        <div class="col-8">
          <p>{{ approveBox.email }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>ธนาคาร</p>
        </div>
        <div class="col-8">
          <p>{{ approveBox.bank }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>เลขที่บัญชี</p>
        </div>
        <div class="col-8">
          <p>{{ approveBox.bankAccount }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>จำนวนเงิน</p>
        </div>
        <div class="col-8">
          <p>฿{{ getCurrency(approveBox.amount ?? 0) }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>หลักฐานการชำระเงิน</p>
        </div>
        <div class="col-8">
          <a-image
            v-if="approveBox.slipImage"
            :src="approveBox.slipImage"
            height="50px"
            width="50px"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <p>หมายเหตุ</p>
        </div>
        <div class="col-8">
          <a-textarea
            v-model:value="approveBox.reason"
            placeholder="ใส่เหตุผลในการดำเนินการ"
          />
        </div>
      </div>
    </a-modal>

    <a-modal
      destroyOnClose="true"
      v-model:visible="visibleAdd"
      title="รายละเอียด"
      @ok="handleOkAdd"
      :confirm-loading="confirmAddLoading"
    >
      <Form
        method="#"
        action="#"
        v-on:submit="onSaveWallet"
        :validation-schema="schema"
        ref="myForm"
      >
        <label>ชื่อ Agent</label>
        <a-select
          show-search
          placeholder="เลือก Agent"
          label-in-value
          v-model:value="selects.user"
          style="width: 100%"
          :filter-option="false"
          :not-found-content="fetching ? undefined : null"
          @search="fetchUser"
          :options="selects.users"
        >
          <template v-if="fetching" #notFoundContent>
            <a-spin size="small" />
          </template>
        </a-select>
        <br />
        <br />
        <vee-input
          label="จำนวนเงิน"
          name="amount"
          type="number"
          :value="walletModel.amount"
          placeholder="Enter amount"
        />
        <p>แนบหลักฐานการชำระเงิน</p>
        <a-upload
          v-model:file-list="fileList"
          :openFileDialogOnClick="fileList.length < 1"
          name="file"
          :multiple="false"
          accept="image/*"
          :action="url + '/wallet/uploadslip'"
          :headers="headers"
          @change="handleChange"
        >
          <a-button>
            <upload-outlined></upload-outlined>
            Click to Upload
          </a-button>
        </a-upload>
        <button ref="submit" style="display: none">Submit</button>
      </Form>
    </a-modal>
  </div>
</template>

<script>
let url = "http://18.142.153.80:9999/romons.payment/api";
import * as paymentservice from "../../../services/payment";
import * as configuration from "../../../middleware/configuration";
import * as userservice from "../../../services/user";
import moment from "moment";
import { message } from "ant-design-vue";
import * as Yup from "yup";
import { ref } from "vue";
import { Form } from "vee-validate";
import { VeeInput } from "@/components";

const columns = [
  {
    title: "หมายเลขรายการ",
    dataIndex: "no",
    key: "no",
  },
  {
    title: "รายการ",
    dataIndex: "actionType",
    key: "actionType",
  },
  {
    title: "วันที่ทำรายการ",
    slots: { customRender: "transDate" },
    key: "createdDate",
  },
  {
    title: "ชื่อ Agent",
    dataIndex: "agentName",
    key: "agentName",
  },
  {
    title: "จำนวนเงิน (บาท)",
    slots: { customRender: "amount" },
    key: "amount",
    align: "right",
  },
  {
    title: "สถานะ",
    slots: { customRender: "status" },
    key: "status",
    align: "center",
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
    width: 100,
  },
];
export default {
  components: {
    VeeInput,
    Form,
  },
  methods: {
    async getTransactions() {
      this.transactionsLoaded = true;
      let data = {
        month: this.month,
        actionType: this.selects.actionType,
        status: this.selects.status,
        transactionNo: this.transactionNo,
        agentName: this.agentName,
      };
      try {
        let res = await paymentservice.getWalletTransactions(data);
        this.transactions = res.data;
      } catch (error) {}
      this.transactionsLoaded = false;
    },
    async fetchUser(value) {
      if (value.length === 0) {
        this.selects.users = [];
        return;
      }

      try {
        let res = await paymentservice.getWalletByKey(value);
        this.selects.users = res.data.map((x) => {
          return { value: x.id, label: x.name };
        });
      } catch (error) {
        message.error("เกิดข้อผิดพลาดในการค้นหา");
      } finally {
        this.fetching = false;
      }
    },
    async getWalletStatus() {
      try {
        let res = await paymentservice.getWalletStatus();
        this.selects.statuses = res.data.map((x) => {
          return { value: x.code, label: x.name };
        });
      } catch (error) {
      } finally {
        this.selects.statusLoaded = true;
      }
    },
    showAddModal() {
      this.visibleAdd = true;
    },
    showModal(id) {
      let wallet = this.transactions.find((x) => x.id === id);
      this.approveBox = {
        id: id,
        no: wallet.no,
        createdDate: wallet.createdDate,
        agentName: wallet.agentName ?? "-",
        fullName: wallet.fullName ?? "-",
        tel: wallet.tel,
        email: wallet.email,
        bank: wallet.bank,
        bankAccount: wallet.bankAccount,
        status: wallet.status,
        statusId: wallet.statusId,
        amount: wallet.amount,
        slipImage: wallet.slipImage,
        reason: "",
      };
      this.visible = true;
    },
    async handleOk() {
      if (!this.approveBox.slipImage) {
        message.warning("ต้องมีหลักฐานการชำระเงิน ถึงจะอนุมัติได้");
        return;
      }
      this.confirmLoading = true;
      try {
        let data = {
          id: this.approveBox.id,
          status: "approve",
          uid: this.uid,
          reason: this.approveBox.reason,
        };
        let res = await paymentservice.updateWalletTransactionStatus(data);
        await this.getTransactions();
        this.visible = false;
        message.success(`บันทึกข้อมูลสำเร็จ`);
      } catch (error) {
        message.error("บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
      } finally {
        this.confirmLoading = false;
      }
    },
    handleOkAdd(e) {
      this.$refs.submit.click();
    },
    async onSaveWallet(values) {
      this.confirmAddLoading = true;
      var image = this.fileList.shift();
      let data = {
        id: 0,
        walletId: this.selects.user.value,
        uid: this.uid,
        actionType: "เติมเงิน",
        transType: "ฝาก",
        amount: values.amount,
        unit: "บาท",
        status: "waiting_approve",
        slipImage:
          image !== undefined ? image.response.url : this.walletModel.picture,
      };
      try {
        let res = await paymentservice.saveWalletTransaction(data);
        message.success(`บันทึกข้อมูลสำเร็จ`);
        this.visibleAdd = false;
        this.getTransactions();
      } catch (error) {
        console.log(error);
      } finally {
        this.confirmAddLoading = false;
      }
    },
    async handleCancel() {
      this.cancelLoading = true;
      try {
        let data = {
          id: this.approveBox.id,
          status: "reject",
          uid: this.uid,
          reason: this.approveBox.reason,
        };
        let res = await paymentservice.updateWalletTransactionStatus(data);
        await this.getTransactions();
        message.success(`บันทึกข้อมูลสำเร็จ`);
        this.visible = false;
      } catch (error) {
        message.error("บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง");
      } finally {
        this.cancelLoading = false;
      }
    },
    onExport() {
      let headers = [];
      let data = this.transactions.map(x => x);
      if (this.transactions.length > 0) {
        headers = Object.keys(this.transactions[0]);
      }

      this.exportCSVFile(
        headers,
        data,
        "Export " + moment().toString("YYMMDDHHmm")
      );
    },
    convertToCSV(objArray) {
      var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      var str = "";

      for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
          if (line != "") line += ",";

          line += array[i][index];
        }

        str += line + "\r\n";
      }

      return str;
    },
    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }

      // Convert Object to JSON
      var jsonObject = JSON.stringify(items);

      var csv = "\ufeff" + this.convertToCSV(jsonObject);

      var exportedFilenmae = fileTitle + ".csv" || "export.csv";

      var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilenmae);
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilenmae);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },
    getCurrency(x) {
      return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
    getDate(value) {
      if (value) return moment(value).format("DD/MM/YYYY HH:mm:ss");
      return "";
    },
  },
  data() {
    return {
      columns: columns,
      url: url,
      visible: false,
      visibleAdd: false,
      approveBox: {
        id: 0,
        reason: "",
      },
      month: moment(),
      transactionNo: "",
      agentName: "",
      transactions: [],
      canAccess: true,
      transactionsLoaded: false,
      confirmLoading: false,
      confirmAddLoading: false,
      walletModel: {},
      fetching: false,
      selects: {
        actionType: [],
        actionTypes: [
          {
            value: "เติมเงิน",
            label: "เติมเงิน",
          },
          {
            value: "เติมเกม",
            label: "เติมเกม",
          },
        ],
        status: [],
        statuses: [],
        statusLoaded: false,
        actionTypesLoaded: true,
        users: [],
        user: null,
      },
    };
  },
  setup() {
    const schema = Yup.object().shape({
      amount: Yup.number()
        .required()
        .label("The amount")
        .min(0)
        .transform((_, val) => {
          return val === "" || isNaN(val) ? "0" : val * 1;
        }),
    });
    const handleChange = (info) => {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }

      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    };
    const fileList = ref([]);
    return {
      schema,
      fileList,
      handleChange,
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    this.getWalletStatus();
  },
};
</script>

<style>
</style>